module.exports = __webpack_public_path__ + "media/swoosh1.6ec23482.ogg";